module.exports = __webpack_public_path__ + "static/barkley-logo-2d3a47ea7b707ed01265ab52d9689ecd.svg";